import { render, staticRenderFns } from "./BackToRoles.vue?vue&type=template&id=66694a77&scoped=true&"
import script from "./BackToRoles.vue?vue&type=script&lang=js&"
export * from "./BackToRoles.vue?vue&type=script&lang=js&"
import style0 from "./BackToRoles.vue?vue&type=style&index=0&id=66694a77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66694a77",
  null
  
)

export default component.exports